import App from '@/models/App'

export default class Favorite extends App {
    static get entity() {
        return 'favorites'
    }
    static all() {
        return this.query().withAllRecursive().get()
    }
    static reset() {
        this.update({
            where: (record) => record.id,
            data: {
                isEdit: false,
            },
        })
    }
    static editable(id) {
        this.update({
            where: id,
            data: {
                isEdit: true,
            },
        })
    }
    static fields() {
        return {
            id: this.attr(''),
            name: this.attr(''),
            url: this.attr(''),
            icon: this.attr(''),
            isEdit: this.boolean(false),
        }
    }
    static apiConfig = {
        actions: {
            fetch(page) {
                return this.get(`/favorites`, {
                    params: {},
                    headers: {
                        Authorization: 'Bearer ' + App.apiToken(),
                        'Accept-Language': App.acceptLanguage(),
                    },
                    dataKey: 'data',
                    baseURL: App.overallURL(),
                })
            },
            create(params) {
                return this.post(`/favorites`, App.post(params), {
                    params: {},
                    headers: {
                        Authorization: 'Bearer ' + App.apiToken(),
                        'Accept-Language': App.acceptLanguage(),
                    },
                    dataKey: 'favorite',
                    baseURL: App.overallURL(),
                })
            },
            update(fovariteId, params) {
                return this.patch(
                    `/favorites/${fovariteId}`,
                    App.patch(params),
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        dataKey: 'favorite',
                        baseURL: App.overallURL(),
                    }
                )
            },
            destroy(fovariteId) {
                return this.delete(`/favorites/${fovariteId}`, {
                    params: {},
                    headers: {
                        Authorization: 'Bearer ' + App.apiToken(),
                        'Accept-Language': App.acceptLanguage(),
                    },
                    delete: fovariteId,
                    baseURL: App.overallURL(),
                })
            },
        },
    }
}
